module.exports = __webpack_public_path__ + "img/1441355969.302efbcd.jpg";